import loadableWithRetry from '../common/loadableWithRetry'

const ExtraServices = loadableWithRetry(() => import('./ExtraServices'));

export default ExtraServices;
